import { GetFlagsDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectFlag = (props) => (
  <SelectFromQuery
    cache="Flags"
    placeholder="All Flags"
    query={GetFlagsDocument}
    selector={(data) =>
      (data?.getFilters?.filters?.flag || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
      }))
    }
    multiple
    {...props}
  />
);

export default SelectFlag;
